import { Theme } from '@material-ui/core';
import { ThemeOptions } from '@material-ui/core/styles';

export const linkTheme = (theme: Theme): ThemeOptions => ({
    overrides: {
        MuiLink: {
            root: {
                '&:hover': {
                    cursor: 'pointer',
                },
            },
            underlineHover: {
                '&:hover': {
                    textDecoration: 'none',
                },
            },
        },
    },
});
